import { bffInstance, oktaInstance } from "../api/axiosInstance";
import {
  useQuery,
  useMutation,
} from "react-query";
import useUserProfileStore from "./UserProfileStore";
import { OKTA_ME_URLS, getOktaMeUrls } from "../../config/okta";
import { APP_ENV,  } from '../../constants';
import { getAccessToken } from "../okta/authService";
import { transformUserProfileResponse } from "../../util/userProfileTransformer";

export const getUnifyUserProfile = async () => {
  const response = await bffInstance.get(`/getUnifyUserProfile`);
  return response.data;
};

export const getUserProfile = async () => {
  const response = await bffInstance.get(`/getUserProfile`);
  return response.data;
};

export const toBearerAuth = (token: string) => `Bearer ${token}`;

export const getOktaProfile = async (enableIdpProxy: boolean = true) => {
  const url = getOktaMeUrls(enableIdpProxy)[APP_ENV as unknown as keyof typeof OKTA_ME_URLS];
  const token = await getAccessToken();
  
  console.log("Idp-Proxy Flag value is : ", enableIdpProxy);
  console.log("Invoking /me URL -> : ", url);

  if (enableIdpProxy) {
    const response = await oktaInstance.get(
      url,
      {
        headers: { Authorization: toBearerAuth(token) }
      }
    );
    const data = response.data;
    return transformUserProfileResponse(data, enableIdpProxy);
  } else {
    const response = await oktaInstance.get(
      url,
      {
        withCredentials: true
      }
    );
    const data = response.data;
    return transformUserProfileResponse(data, enableIdpProxy);
  }
};

export const useOktaUserProfileData = (enableIdpProxyFlag:boolean) => {
  const store = useUserProfileStore();

  const oktaProfile = useQuery({
    queryKey: ["oktaProfile"],
    queryFn: () => getOktaProfile(enableIdpProxyFlag),
    enabled: (enableIdpProxyFlag === false || enableIdpProxyFlag === true),
    retry: 3,
    onSuccess(data) {
      console.log("oktaUserProfile 1",data)
      store.setOktaUserProfile(data);
    },
  });

  return {
    oktaProfileData: store.oktaUserProfile,
    isLoading: oktaProfile.isLoading,
    isFetching:  oktaProfile.isFetching,
    error:  oktaProfile.error,
    refetch: oktaProfile.refetch,
  };

}

export const useUserProfileData = (enableIdpProxyFlag: boolean | undefined) => {
  const store = useUserProfileStore();

  const unifyProfile = useQuery({
    queryKey: ["unifyProfile"],
    queryFn: getUnifyUserProfile,
    onSuccess(data) {
      store.setUnifyUserProfile(data);
    },
  });

  const iamProfile = useQuery({
    queryKey: ["iamProfile"],
    queryFn: getUserProfile,
    onSuccess(data) {
      store.setIamUserProfile(data);
    },
  });

  const oktaProfile = useQuery({
    queryKey: ["oktaProfile"],
    queryFn: () => getOktaProfile(enableIdpProxyFlag),
    enabled:  (enableIdpProxyFlag === false || enableIdpProxyFlag === true),
    retry: 3,
    onSuccess(data) {
      store.setOktaUserProfile(data);
    },
  });

  return {
    unifyProfileData: store.unifyUserProfile,
    iamProfileData: store.iamUserProfile,
    oktaProfileData: store.oktaUserProfile,
    isLoading: unifyProfile.isLoading || iamProfile.isLoading || oktaProfile.isLoading,
    isFetching: unifyProfile.isFetching || iamProfile.isFetching || oktaProfile.isFetching,
    error: unifyProfile.error || iamProfile.error || oktaProfile.error,
    refetch: unifyProfile.refetch || iamProfile.refetch || oktaProfile.refetch,
  };

};

export const updateUserLastLogin = async (
  lastLogin: Date,
  enterpriseId: string,
  storeId: string,
  permissions: string[]
) => {
  const res = await bffInstance.put("/updateUserLastLogin", {
    lastLogin,
    enterpriseId,
    storeId,
    permissions
  });
  return res.data;
};

export const useUpdateUserLastLogin = () => {
  const { data, mutate } = useMutation(
    (data: { lastLogin: any; enterpriseId: any; storeId: string, permissions:string[] }) =>
      updateUserLastLogin(data.lastLogin, data.enterpriseId, data.storeId, data.permissions),
    {
      onError: (error: any) => {
        console.error("Mutation failed:", error);
      }
    }
  );
  return { data, mutate };
};


const updateUserCNumbers = async (
  cNumbers: string[]
) => {
  const res = await bffInstance.put("/updateUserCNumber", {
    cNumbers
  });
  return res.data;
};

export const useUpdateUserCNumber = () => {
  const { data, mutate } = useMutation(
    (data: { cNumbers: any }) =>
      updateUserCNumbers(data.cNumbers),
    {
      onError: (error: any) => {
        console.error("Mutation failed:", error);
      }
    }
  );
  return { data, mutate };
};
